import React from 'react';
import {
	SypacButton,
	SypacIcon,
	SypacText,
} from '@sypac/component-library-react';
import { T, useTranslate } from '@tolgee/react';
import { useNavigate, useParams } from 'react-router-dom';
import { Logo } from '../../assets/Logo';
import orderStore from '../../stores/order-store';

interface ThankYouProps {
	client: boolean;
}

const ThankYou: React.FC<ThankYouProps> = ({ client }) => {
	const navigate = useNavigate();
	const { t } = useTranslate();
	const { storeId } = useParams();

	const renderProducerButtons = () => {
		return (
			<SypacButton
				variant="secondary"
				size="small"
				className="flex items-center"
			>
				<a
					href={`/products/${storeId}`}
					className="w-full h-[30px] flex justify-center rounded-lg m-0 transition"
				>
					<SypacText variant="body-regular-medium">
						<p className="text-primary-violet">
							<T keyName="thankYou.gotIt">Got it</T>
						</p>
					</SypacText>
				</a>
			</SypacButton>
		);
	};

	const renderClientButtons = () => {
		return (
			<div className="flex flex-col sm:flex-row gap-6.25">
				<SypacButton
					variant="secondary"
					size="small"
					className="flex items-center"
				>
					<a
						href="/store"
						className="w-full h-[30px] flex justify-center rounded-lg m-0 transition"
					>
						<SypacIcon
							size="custom"
							width="10px"
							height="12px"
							icon-name="Alt Arrow Left"
						/>
						<SypacText variant="body-regular-medium">
							<p className="text-primary-violet whitespace-nowrap">
								<T keyName="thankYou.backToStore">Back to store</T>
							</p>
						</SypacText>
					</a>
				</SypacButton>

				<SypacButton
					variant="secondary"
					size="small"
					className="flex items-center animate-tr-b-t-1"
				>
					<a
						href="/orders"
						onClick={(e) => {
							e.preventDefault();
							if (!orderStore.orderId && client && storeId) {
								orderStore.setOrderId(storeId);
							}
							navigate('/orders');
						}}
						className="w-full min-w-[109px] h-[30px] flex justify-center bg-primary-violet border-none transition hover:bg-primary-violet/70 rounded-lg m-0"
					>
						<SypacText variant="body-regular-medium">
							<p className="text-white whitespace-nowrap">
								<T keyName="thankYou.viewOrder">View order</T>
							</p>
						</SypacText>
					</a>
				</SypacButton>
			</div>
		);
	};

	return (
		<div className="h-[calc(100vh-130px)] flex flex-col items-center justify-center mt-[68px] sm:mt-0 px-[12px] sm:px-0">
			<Logo />
			<div className="mb-6 text-center sm:text-left">
				<SypacText variant="heading-5">
					<p className="text-dark font-medium">
						{client
							? t(
									'thankYou.yourOrder',
									'Your order is currently being processed',
							  )
							: t('thankYou.thankYou', 'Thank you!')}
					</p>
				</SypacText>
			</div>
			<div className="max-w-[749px] mb-[120px]">
				<SypacText variant="body-normal-medium">
					<p className="text-dark-2 text-center">
						{client
							? t(
									'thankYou.weAreProcessingYourOrder',
									"Once processed, you'll receive a notification confirming the order acceptance and detailing the next steps. Thank you for choosing SYPAC.",
							  )
							: t(
									'thankYou.productPlacementIsNowUnderReview',
									"Your product placement is now under review. We will notify you once it's ready be published on Sypac.",
							  )}
					</p>
				</SypacText>
			</div>
			<div className="w-full sm:w-fit">
				{client ? renderClientButtons() : renderProducerButtons()}
			</div>
		</div>
	);
};

export default ThankYou;
